import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

interface MetaDecoratorProps {
  title: string;
  description: string;
  keywords: string;
  canonical?: string;
  robots?: string;
  hreflang?: string;
}

const MetaDecorator = ({ title, description, keywords, canonical, robots, hreflang }: MetaDecoratorProps) => (
  <HelmetProvider>
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {robots ? <meta name="robots" content={robots} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {hreflang && canonical ? <link rel="alternate" hrefLang={hreflang} href={canonical} /> : null}
    </Helmet>
  </HelmetProvider>
);

export default MetaDecorator;
